import { render, staticRenderFns } from "./MessageBoxAttention.vue?vue&type=template&id=500e7ade&scoped=true&"
import script from "./MessageBoxAttention.vue?vue&type=script&lang=js&"
export * from "./MessageBoxAttention.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoxAttention.vue?vue&type=style&index=0&id=500e7ade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e7ade",
  null
  
)

export default component.exports